module.exports = __webpack_public_path__ + "img/1_Luxury.fd13eeee.png";